import { render, staticRenderFns } from "./ReadOnly.vue?vue&type=template&id=018b212e&scoped=true&"
import script from "./ReadOnly.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReadOnly.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ReadOnly.vue?vue&type=style&index=0&id=018b212e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018b212e",
  null
  
)

export default component.exports